module.exports = __webpack_public_path__ + "static/media/academyIcons.d5fd8f84.svg";